import React, { useState } from 'react';
import { Flex } from '@chakra-ui/layout';
import { Link } from 'react-router-dom';
import { Button } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { APP_VIEW, getAppView } from '../../../services/VersionManagement/VersionManagementService';

export interface NavBarProps {
  handleLoadingSpinner: (value: boolean) => void;
  bookmarks: number;
}
export const NavBar = (props: NavBarProps): JSX.Element => {
  const { handleLoadingSpinner, bookmarks } = props;
  const [appView] = useState<APP_VIEW>(getAppView());
  
  return (
    <Flex width={'100%'} justify={'flex-end'}>
      <Link
        to={{
          pathname: '/bookmarks',
        }}
        // style={{ width: '100%' }}
      >
        <Button
          // w={'100%'}
          colorScheme={'blue'}
          variant="outline"
          disabled={!bookmarks}
          onClick={() => handleLoadingSpinner(true)}
          style={{visibility: appView === APP_VIEW.MIN ? "hidden" : "visible", height: appView === APP_VIEW.MIN ? "0px" : ""}}
          >
            Zum Merkzettel ({bookmarks})
        </Button>
      </Link>
    </Flex>
  );
};
